import React from "react";
import { Outlet } from "react-router-dom";
import SideCart from "../ecommerce/globalcomponents/SideCart/SideCart";
import MobileBottomNav from "../ecommerce/globalcomponents/mobile/MobileBottomNav/MobileBottomNav";
import { MOBILE_NAV_EXCLUDED_PATHS } from "../ecommerce/globalcomponents/mobile/mobileRoutes";

const EcommLayout: React.FC = () => {
  return (
    <>
      <div className="ecomm-layout">
        <main className="ecomm-content">
          <Outlet />
        </main>
        <SideCart />
        <MobileBottomNav excludedPaths={MOBILE_NAV_EXCLUDED_PATHS} />
      </div>
    </>
  );
};

export default EcommLayout;
